import type { DependencyList } from "react";
import {
  useHotkeys,
  type HotkeyCallback,
  type Keys,
  type Options,
} from "react-hotkeys-hook";

export const APP_HOTKEY_SCOPES = {
  documentTagEditor: "document-tag-editor",
} as const;

type AppHotkeyScope =
  (typeof APP_HOTKEY_SCOPES)[keyof typeof APP_HOTKEY_SCOPES];

type AppHotkeyOptions = Omit<Options, "scopes"> & {
  scope?: AppHotkeyScope | AppHotkeyScope[];
};

export function useAppHotkeys<T extends HTMLElement>(
  keys: Keys,
  callback: HotkeyCallback,
  options?: AppHotkeyOptions,
  dependencies?: DependencyList
) {
  const { scope, enableOnFormTags = false, enableOnContentEditable = false, ...rest } =
    options ?? {};

  return useHotkeys<T>(
    keys,
    callback,
    {
      ...rest,
      scopes: scope,
      enableOnFormTags,
      enableOnContentEditable,
    },
    dependencies
  );
}
